<template>

    <m-edit1/>

    <m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-div v-bind='{...{},...{}}' :style='""' class="nav-div" >
                <template #default>   <m-nav-503 v-bind='{...{"menuPosition":"blog_nav","shoppingCart":false},...{}}' :style='""' class="mt-3  fixed-top  col-lg-9 col-md-10  col-sm-11  col-11" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/panel.mixitweb.com","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="btn btn-primary mx-1" >
                <template #default>پنل کاربری   </template>
                </m-button></template>
                </m-a><m-a v-bind='{...{"href":"{\"name\":\"countactus\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="btn btn-secondary" >
                <template #default>تماس باما   </template>
                </m-button></template>
                </m-a></template>
                </m-nav-503></template>
                </m-div><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"box-shadow: rgb(0 0 0 \/ 20%) 1px 1px 16px 5px; \nborder-radius:15px; \nbackground-image: url(https:\/\/api.mixitweb.com\/storage\/assets\/footerbg.svg);\nbackground-repeat: no-repeat;\nbackground-size: contain;"' class="bg-secondary site-layout-footer " >
                <template #default>   <m-footer-100 v-bind='{...{"menuPosition":"blog_footer","searchInput":"mSearchInput200"},...{}}' :style='""' class="p-3 " ></m-footer-100></template>
                </m-div><m-a v-bind='{...{"href":"tel:09365249788","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button-903 v-bind='{...{},...{}}' :style='"z-index:10;"' class="bg-primary" >
                <template #default>   <m-icon v-bind='{...{"icon":"telephone-outbound-fill"},...{}}' :style='""' class="h4" ></m-icon></template>
                </m-button-903></template>
                </m-a>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav503 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav503/Nav503'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton from '@moeinmdn/miw-alpha-components/src/package/Tags/Button'; import mFooter100 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer100/Footer100'; import mButton903 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button903'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon';

export default {
    name: 'HomeView',
    components: {mEdit1, mLoading3,mUpdateSiteMessage1,mDiv,mNav503,mA,mButton,mFooter100,mButton903,mIcon },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
